<template>
    <div class="row" v-if="isAvailableForView">
        <div class="col-lg-12 mb-4">
            <div class="box">
                <div class="box-offset">
                    <div class="box-ttl-wrap">
                        <div class="box-ttl">Tags</div>
                    </div>
                    <div class="buttons--row buttons--row-2 mb-3">
                        <div class="search--block">
                            <button
                                class="search--block-btn"
                                @click="getTagsList"
                                type="submit">
                                <img src="/img/svg/icons-search.svg" alt="">
                            </button>
                            <input
                                type="search"
                                v-model="filters.search"
                                class="search--block-txt"
                                placeholder="Search by Tag Name"
                                @input="handleSearch"
                            />
                        </div>
                        <button
                            class="btn btn--outline-primary btn--middle"
                            @click="showCustomModal('tag-modal', 1)"
                        >+ Add New</button>

                        <AddNewItemModal
                            title="Add New Tag"
                            title2="Tag"
                            :id="getCustomModalId('tag-modal', 1)"
                            confirm-text="Save"
                            reject-text="Cancel"
                            type="input"
                            @confirm="addNewTag"
                        ></AddNewItemModal>
                    </div>
                    <div class="table-holder table-responsive">
                        <table class="table">
                            <thead>
                            <tr>
                                <th>
                                    <nobr>
                                        <a href="javascript:void(0)" @click.prevent="changeSortList('name')">Tags Name<i
                                            class="fas fa-sort"></i></a>
                                    </nobr>
                                </th>
                                <th>
                                    <nobr>
                                        <a href="javascript:void(0)" @click.prevent="changeSortList('count')">Show a
                                            Counter<i class="fas fa-sort"></i></a>
                                    </nobr>
                                </th>
                                <th class="text-right" style="width: 5rem">Action</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr
                                v-for="tag in tags"
                                :key="tag.id"
                            >
                                <template v-if="activeTag.id === tag.id">
                                    <td colspan="2">
                                        <input type="text" class="form-control mb-0 w-100" v-model="tag.name">
                                    </td>
                                </template>
                                <template v-else>
                                    <td>
                                        <b>{{ tag.name }}</b>
                                    </td>
                                    <td>
                                        {{ tag.users_count }}
                                    </td>
                                </template>
                                <td class="text-right">
                                    <div class="action-block">
                                        <button
                                            class="edit-link"
                                            v-if="activeTag.id === tag.id"
                                        >
                                            <img
                                                src="/img/svg/check-5.svg"
                                                alt="Save"
                                                @click="saveTag(tag)"
                                            >
                                        </button>
                                        <button class="edit-link" v-else>
                                            <img
                                                src="/img/svg/icons-pen.svg"
                                                alt="Edit"
                                                @click="editTag(tag)"
                                            >
                                        </button>
                                        <button
                                            v-show="activeTag.id !== tag.id"
                                            class="delete-link"
                                            @click="showDeleteModal(tag.id)"
                                        >
                                            <img src="/img/svg/on.svg" alt="delete">
                                        </button>
                                        <ActionModal
                                            confirm-text="Yes"
                                            reject-text="No"
                                            :modalId="getDeleteModalId(tag.id)"
                                            @confirm="deleteTag(tag.id)"
                                        >
                                            <template #body>
                                                <div class="text-center mb-4">
                                                    <h4>
                                                        Are you sure you want <br> to delete this item?
                                                    </h4>
                                                </div>
                                            </template>
                                        </ActionModal>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <Pagination
                        :currentPage="pagination.current_page"
                        :lastPage="pagination.last_page"
                        @changeItemsPerPage="changeItemsPerPage"
                        @changePage="changePage" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TagsServices from "./TagsServices";
import ActionModal from "../../../../../resources/js/components/ActionModal.vue";
import AddNewItemModal from "../../../../../resources/js/components/AddNewItemModal.vue";
import Pagination from "../../../../../resources/js/components/Pagination.vue";
import ModalHandler from "../../../../../resources/js/mixins/ModalHandler";
import SortDirectionHandler from "../../../../../resources/js/mixins/SortDirectionHandler";
import PaginationHandler from "../../../../../resources/js/mixins/PaginationHandler";
import {createDebouncedFunction} from "../../../../../resources/js/plugins/debounce";
import _ from "lodash";


export default {
    name: 'TagsList',
    props: {
        isAvailableForView: {
            type: Boolean,
            required: true
        },
    },
    components: {Pagination, AddNewItemModal, ActionModal},
    mixins: [ModalHandler, SortDirectionHandler,PaginationHandler],
    data() {
        return {
            activeTag: {},
            newTag: {},
            showAddNewItemModal: false,
            tags: [],
            updatedTag: {},
            filters: {
                search: '',
                sortBy: 'name',
                sortDir: 'asc',
                page: 1,
                withPagination: 1,
                perPage: 10
            },
            pagination: {
                current_page: 1,
                last_page: 1,
            },
        }
    },
    methods: {
        delayedSearch: _.debounce(function () {
            this.getTagsList()
        }, 500),
        editTag(tag) {
            this.activeTag = tag
        },
        getList(filters) {
            this.getTagsList(filters)
        },
        async addNewTag(text) {
            if (!text || text.trim() === '') {
                this.$showErrorMessage('Please enter the tag name');
            } else {
                this.$showLoadingMessage()
                try {
                    const response = await TagsServices.addNewTag(text);
                    this.tags.push(response.data);
                    await this.getTagsList();
                    $('#tag-modal-1').modal('hide');
                    this.$showSuccessMessage('New tag added')
                } catch (error) {
                    this.$showErrorMessage('The tag was not added. Please try again');
                    console.error(error);
                }
            }
        },
        async deleteTag(id) {
            this.$showLoadingMessage();
            this.tags = this.tags.filter((tag) => tag.id !== id)
            try {
                this.$showSuccessMessageDelete();
                await TagsServices.delete(id)
            } catch (error) {
                this.$showErrorMessage('The tag was not deleted. Please try again');
            }
        },
        async getTagsList() {
            try {
                const {data: tagsList} = await TagsServices.getTagsList(this.filters)
                this.tags = tagsList.data
                this.pagination.current_page = tagsList.current_page
                this.pagination.last_page = tagsList.last_page
            } catch (e) {
                this.$showErrorMessage('List of tags was not uploaded. Server error');
                console.error(e)
            }
        },
        async saveTag(tag) {
            if (!tag.name || tag.name.trim() === '') {
                this.$showErrorMessage( 'The tag name is empty');
            } else {
                this.$showLoadingMessage()
                const updatedTagData = {id: tag.id, name: tag.name, users_count: tag.users_count};
                try {
                    const {data: updatedTag} = await TagsServices.updateTag(tag.id, tag.name);
                    const tagIndex = this.tags.findIndex(t => t.id === tag.id);
                    if (tagIndex !== -1) {
                        this.tags[tagIndex] = updatedTagData;
                    }
                    this.activeTag = updatedTag
                    this.$showSuccessMessage('The tag was updated!')

                } catch (e) {
                    this.$showErrorMessage(' The tag was not updated');
                }
            }
        },
        handleSearch() {
            this.filters.page = 1
            this.delayedSearch();
        },

    },
    mounted() {
        this.getTagsList();
    },

}

</script>

<style scoped>

</style>
